import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/element/HomePageHeroNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/element/PromotionSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/section/TestimonialSlider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@heroui/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
